import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const getAdminOffersPerAuction = async (id, context = {}) => {
  if (id === null) {
    return;
  }

  try {
    const getAllOffersFn = httpsCallable(functions, 'getAllOffersV2');
    const result = await getAllOffersFn({
      auctionId: id,
      groupId: context.activeGroupId || context.groupId,
      requestedApp: 'group_web',
    });
    return result.data.data;
  } catch (error) {
    console.error('Error obteniendo ofertas para admin:', error);
    notifyPermissionDenied(error);
    return [];
  }
};
